// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa240.stage.monatest.icu/auto-open-api-spec.yaml 1.6.65
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializes PrescriptionFrequency from database
 * @see #/components/schemas/PrescriptionFrequency - reference to schema in open-api-spec.yaml
 * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
 * @version 1.6.65
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface PrescriptionFrequency {
    /**
     * The code for the prescription frequency
     * @dataFormat uuid
     */
    readonly code: string;
    /**
     * The prescription frequency SNOMED code.
     *
     */
    snomed_code?: string | null;
    /**
     * The display name of Prescription Frequency
     *
     */
    display_name: string;
    /**
     * The timing code for Prescription Frequency
     *
     */
    timing_code: string;
    /**
     * The timing display name for Prescription Frequency
     *
     */
    timing_display_name: string;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for PrescriptionFrequency
 */
export namespace PrescriptionFrequency {
    /**
     * PrescriptionFrequency Frontend Model with camelCase properties
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * The code for the prescription frequency
         * @dataFormat uuid
         */
        readonly code: string;
        /**
         * The prescription frequency SNOMED code.
         * @type string (`dataFormat` is missing)
         */
        snomedCode?: string | null;
        /**
         * The display name of Prescription Frequency
         * @type string (`dataFormat` is missing)
         */
        displayName: string;
        /**
         * The timing code for Prescription Frequency
         * @type string (`dataFormat` is missing)
         */
        timingCode: string;
        /**
         * The timing display name for Prescription Frequency
         * @type string (`dataFormat` is missing)
         */
        timingDisplayName: string;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * PrescriptionFrequency DTO
     * Transforms PrescriptionFrequency model from/to API object
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend PrescriptionFrequency model */
        static toModel(obj: PrescriptionFrequency): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend PrescriptionFrequency model */
        static toApi(obj: Model): PrescriptionFrequency {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as PrescriptionFrequency;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
